const MIN_SR_SERIES_NUMBER = 4700;

export function getNextSeriesNumber({
  displaySetService,
  modality,
  minSeriesNumber,
  studyInstanceUID,
}) {
  const activeDisplaySets = displaySetService.getActiveDisplaySets();
  const scopedDisplaySets = studyInstanceUID
    ? activeDisplaySets.filter(ds => ds.StudyInstanceUID === studyInstanceUID)
    : activeDisplaySets;
  const modalityDisplaySets = scopedDisplaySets.filter(ds => ds.Modality === modality);
  const modalitySeriesNumbers = modalityDisplaySets.map(ds => ds.SeriesNumber);
  const maxSeriesNumber = Math.max(...modalitySeriesNumbers, minSeriesNumber);

  const allSeriesNumbers = scopedDisplaySets.map(ds => ds.SeriesNumber);

  let finalSeriesNumber = maxSeriesNumber + 1;
  while (allSeriesNumbers.includes(finalSeriesNumber)) {
    finalSeriesNumber++;
  }

  return { SeriesNumber: finalSeriesNumber, InstanceNumber: 1 };
}

export function getSRSeriesAndInstanceNumber({
  displaySetService,
  SeriesInstanceUid,
  studyInstanceUID,
}) {
  if (!SeriesInstanceUid) {
    return getNextSeriesNumber({
      displaySetService,
      modality: 'SR',
      minSeriesNumber: MIN_SR_SERIES_NUMBER,
      studyInstanceUID,
    });
  }

  const displaySetsMap = displaySetService.getDisplaySetCache();
  const displaySets = Array.from(displaySetsMap.values());
  const srDisplaySet = displaySets.find(
    ds =>
      ds.Modality === 'SR' &&
      ds.SeriesInstanceUID === SeriesInstanceUid &&
      (!studyInstanceUID || ds.StudyInstanceUID === studyInstanceUID)
  );
  const InstanceNumber = srDisplaySet?.instances?.length + 1;

  if (!srDisplaySet?.SeriesNumber || !InstanceNumber) {
    return getNextSeriesNumber({
      displaySetService,
      modality: 'SR',
      minSeriesNumber: MIN_SR_SERIES_NUMBER,
      studyInstanceUID,
    });
  }

  return {
    SeriesNumber: srDisplaySet.SeriesNumber,
    InstanceNumber,
    referenceDisplaySet: srDisplaySet,
  };
}
